import React, { useState, useEffect, useRef } from "react";
import TablaGenerica from "../../components/Table/tablaGenerica";
import CustomModal from "../../components/customModal";
import CrearProducto from "./productos/crearproducto";
import HistorialModal from "./historial/HistorialModal";
import {
  Grid,
  TextField,
  Button,
  Menu,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Chip,
  Tooltip,
  IconButton,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MultiBultoModal from "./productos/productMultiPack";
import CrearProductoCombo from "./productos/combo";
import { useNavigate } from "react-router-dom";
import ingressService from "../../services/ingressService";
import LoadMasive from "./productos/loadMasive";
import AuthService from "../../services/authService";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import ProductLabel from "./productos/productLabel";
import productsServices from "../../services/productsService";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const initialAlert = {
  severity: "success",
  message: "",
};

const Inventario = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenCombo, setModalOpenCombo] = useState(false);
  const [openModalMultiPack, setOpenModalMultiPack] = useState(false);
  const [modalHistorialOpen, setModalHistorialOpen] = useState(false);
  const [productoCreado, setProductoCreado] = useState(0);
  const [productoSKU, setProductoSKU] = useState("");
  const [productoNombre, setProductoNombre] = useState("");
  const [filterText, setFilterText] = useState("");
  const navigate = useNavigate();
  const [openLoadMasiveModal, setOpenLoadMasiveModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [searchInventory, setSearchInventory] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    active: "true", // por defecto, solo productos Activos
    tipo: "",
    stock: "", // Todos / con / sin
  });
  const [printLabelOpen, setPrintLabelOpen] = useState(false);
  const [printLabelLoading, setPrintLabelLoading] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState({
    ean: "",
    name: "",
    sku: "",
    isMultipack: false,
    multipackProducts: [],
  });
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isEnabling, setIsEnabling] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingIds, setLoadingIds] = useState([]);
  const [alertObj, setAlertObj] = useState(initialAlert);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const hasCreatePermission = AuthService.hasPermission("create", "product");
  const hasUpdatePermission = AuthService.hasPermission("update", "product");
  const hasDeletePermission = AuthService.hasPermission("delete", "product");

  const handleActionsMenuOpen = (event, rowId) => {
    setActionsMenuAnchor(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleActionsMenuClose = () => {
    setActionsMenuAnchor(null);
    setSelectedRowId(null);
  };

  // Filtros inline (Estado / Tipo): aplican al instante (el useEffect refetchea
  // cuando cambia activeFilters).
  const handleFilterSelect = (key, value) =>
    setActiveFilters((prev) => ({ ...prev, [key]: value }));

  const inventory = async (
    page = 1,
    pageSize = 10,
    filters = activeFilters
  ) => {
    try {
      setSearchInventory(true);

      // Tipo de producto -> flags del backend.
      // Convencional: is_combo=false AND is_multipack=false. Combo: is_combo=true.
      // Multibulto: is_multipack=true. Todos: sin filtro.
      let isCombo;
      let isMultipack;
      if (filters.tipo === "combo") {
        isCombo = true;
      } else if (filters.tipo === "multibulto") {
        isMultipack = true;
      } else if (filters.tipo === "convencional") {
        isCombo = false;
        isMultipack = false;
      }

      const result = await ingressService.getInventory(
        filterText,
        filters.active,
        isCombo,
        page,
        pageSize,
        isMultipack,
        filters.stock
      );

      let data = result?.data || [];

      // Los combos ya vienen con stock/stock_out calculado EN VIVO desde el backend
      // (comboLiveStock en product-api). Antes se recalculaba acá con N+1 requests
      // concurrentes que fallaban inconsistentemente (combos mostrando 0).
      setProducts(data);

      setSearchInventory(false);
    } catch (error) {
      console.error("Hubo un error:", error);
      setSearchInventory(false);
    }
  };

  const handleCreateProducto = (page = 1, pageSize = 10) => {
    inventory(page, pageSize);
  };

  // Busca desde 1 carácter (para SKUs cortos como "CC") con un debounce de 350ms
  // para no disparar una request por cada tecla.
  const searchDebounceRef = useRef(null);
  const handleFilterChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => setFilterText(value), 350);
  };

  useEffect(() => {
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, []);

  useEffect(() => {
    inventory();
  }, [productoCreado, filterText, activeFilters]);

  const handleOpenModalEdit = (product) => {
    setProductoSKU(product.id);
    if (product.is_combo) setModalOpenCombo(true);
    else if (product.is_multipack) setOpenModalMultiPack(true);
    else setModalOpen(true);
  };

  const handleOpenModalHistorial = (sku) => {
    setProductoSKU(sku.id);
    setProductoNombre(sku.name || "");
    setModalHistorialOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setProductoSKU("");
  };

  const handleCloseModalCombo = () => {
    setModalOpenCombo(false);
    setProductoSKU("");
  };

  const handleCloseModalMultiPack = () => {
    setOpenModalMultiPack(false);
    setProductoSKU("");
  };

  const handleCloseModalHistorial = () => {
    setModalHistorialOpen(false);
    setProductoSKU("");
  };

  const handlePrintLabel = async (
    ean,
    name,
    sku,
    isMultipack = false,
    productId = null
  ) => {
    let multipackProducts = [];
    if (isMultipack && productId) {
      try {
        setPrintLabelLoading(true);
        const res = await productsServices.getProductsBySku(productId);
        const products = Array.isArray(res.data) ? res.data : [res.data];
        multipackProducts = products.filter((product) => !product.is_multipack);
        console.log(multipackProducts);
      } catch (error) {
        console.error("Error al obtener información del multibulto:", error);
        multipackProducts = [];
      } finally {
        setPrintLabelLoading(false);
      }
    }

    setSelectedLabel({
      ean,
      name,
      sku,
      isMultipack,
      multipackProducts,
    });
    setPrintLabelOpen(true);
  };

  const handleOpenConfirmDialog = (id, currentStatus) => {
    setSelectedProductId(id);
    setIsEnabling(!currentStatus);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setSelectedProductId(null);
    setIsEnabling(false);
    setOpenConfirmDialog(false);
  };

  const handleToggleStatus = async () => {
    setLoading(true);
    setLoadingIds((prev) => [...prev, selectedProductId]);

    try {
      if (selectedProductId) {
        if (isEnabling) {
          await productsServices.enableProduct(selectedProductId);
          setAlertObj({
            severity: "success",
            message: "Producto habilitado exitosamente.",
          });
        } else {
          await productsServices.deleteProduct(selectedProductId);
          setAlertObj({
            severity: "success",
            message: "Producto inhabilitado exitosamente.",
          });
        }
      }
      handleCreateProducto(page + 1, rowsPerPage);
    } catch (error) {
      console.error("Error al cambiar el estado del producto:", error);
      setAlertObj({
        severity: "error",
        message: "Hubo un error al intentar cambiar el estado del producto.",
      });
    } finally {
      setSnackbarOpen(true);
      setLoadingIds((prev) =>
        prev.filter((loadingId) => loadingId !== selectedProductId)
      );
      handleCloseConfirmDialog();
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container padding={5}>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "#1a1a1a",
              pl: 1.5,
              borderLeft: (theme) => `4px solid ${theme.palette.secondary.main}`,
              lineHeight: 1.5,
            }}
          >
            Inventario
          </Typography>
          {hasCreatePermission && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<UploadFileIcon />}
                sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
                onClick={() => setOpenLoadMasiveModal(true)}
              >
                Carga masiva
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3 }}
                onClick={() => navigate("/create-product")}
              >
                Nuevo producto
              </Button>
            </Box>
          )}
        </Box>

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            p: 1.5,
            mb: 2,
            borderRadius: "10px",
            border: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <TextField
            size="small"
            label="Buscar por SKU, EAN y NOMBRE"
            variant="outlined"
            onChange={handleFilterChange}
            sx={{
              width: "280px",
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={activeFilters.active}
              label="Estado"
              onChange={(e) => handleFilterSelect("active", e.target.value)}
              sx={{ borderRadius: "8px", backgroundColor: "#fff" }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="true">Activo</MenuItem>
              <MenuItem value="false">Inactivo</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Tipo de producto</InputLabel>
            <Select
              value={activeFilters.tipo}
              label="Tipo de producto"
              onChange={(e) => handleFilterSelect("tipo", e.target.value)}
              sx={{ borderRadius: "8px", backgroundColor: "#fff" }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="convencional">Convencional</MenuItem>
              <MenuItem value="combo">Combo</MenuItem>
              <MenuItem value="multibulto">Multibulto</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Stock</InputLabel>
            <Select
              value={activeFilters.stock}
              label="Stock"
              onChange={(e) => handleFilterSelect("stock", e.target.value)}
              sx={{ borderRadius: "8px", backgroundColor: "#fff" }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="con">Con stock</MenuItem>
              <MenuItem value="sin">Sin stock</MenuItem>
            </Select>
          </FormControl>
        </Paper>

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <TablaGenerica
            data={products?.results || []}
            columns={[
              {
                title: "Item",
                field: "name",
                width: 500,
                sorting: false,
                render: (row) => (
                  <Box
                    sx={{
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      minHeight: 60,
                    }}
                  >
                    <Chip
                      size="small"
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: row.active ? "#4caf50" : "#f44336",
                        mr: 1.5,
                        flexShrink: 0,
                        "& .MuiChip-label": { display: "none" },
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.95rem",
                          color: "text.primary",
                        }}
                      >
                        {row.name}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Chip
                          label={row.is_combo ? "Combo" : row.is_multipack ? "Multibulto" : "Convencional"}
                          size="small"
                          sx={{
                            fontSize: "0.7rem",
                            height: 20,
                            backgroundColor: row.is_combo ? "#E8F0FE" : row.is_multipack ? "#f3e5f5" : "#f5f5f5",
                            color: row.is_combo ? "#2563EB" : row.is_multipack ? "#7b1fa2" : "#616161",
                            fontWeight: 500,
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary", fontSize: "0.78rem" }}
                        >
                          EAN: {row.is_combo ? "—" : (row.ean_id || "—")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ),
              },
              {
                title: "SKU",
                field: "sku_id",
                width: 100,
                sorting: false,
                render: (row) => (
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "#2563EB", fontSize: "0.85rem" }}>
                    {row.sku_id}
                  </Typography>
                ),
              },
              {
                title: "Pend. Ingreso",
                field: "stock_in",
                width: 50,
                sorting: false,
                render: (row) => (
                  <Typography variant="body2" sx={{ fontWeight: 500, color: row.stock_in > 0 ? "#e65100" : "#999", fontSize: "0.9rem" }}>
                    {row.stock_in || 0}
                  </Typography>
                ),
              },
              {
                title: "Stock",
                field: "stock",
                width: 50,
                sorting: false,
                render: (row) => (
                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
                    {row.stock || 0}
                  </Typography>
                ),
              },
              {
                title: "Pend. Egreso",
                field: "stock_out",
                width: 50,
                sorting: false,
                render: (row) => (
                  <Typography variant="body2" sx={{ fontWeight: 500, color: row.stock_out > 0 ? "#e65100" : "#999", fontSize: "0.9rem" }}>
                    {row.stock_out || 0}
                  </Typography>
                ),
              },
              {
                title: "Stock Disp.",
                field: "stock_disponible",
                sorting: false,
                width: 50,
                render: (rowData) => {
                  const disp = (rowData.stock || 0) - (rowData.stock_out || 0);
                  return (
                    <Chip
                      label={disp}
                      size="small"
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.85rem",
                        backgroundColor: disp > 0 ? "#e8f5e9" : disp === 0 ? "#fff3e0" : "#ffebee",
                        color: disp > 0 ? "#2e7d32" : disp === 0 ? "#e65100" : "#c62828",
                        borderRadius: "6px",
                        minWidth: 40,
                      }}
                    />
                  );
                },
              },
              {
                title: "Acciones",
                sorting: false,
                width: 80,
                render: (row) => (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Tooltip title="Más acciones" arrow>
                      <IconButton
                        onClick={(e) => handleActionsMenuOpen(e, row.id)}
                        size="small"
                        sx={{
                          borderRadius: "8px",
                          transition: "background-color 0.2s",
                          "&:hover": { backgroundColor: "#E8F0FE" },
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>

                      <Menu
                        anchorEl={actionsMenuAnchor}
                        open={
                          Boolean(actionsMenuAnchor) && selectedRowId === row.id
                        }
                        onClose={handleActionsMenuClose}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        {!row.is_combo && [
                          <MenuItem
                            key="print"
                            onClick={() => {
                              handlePrintLabel(
                                row.ean_id,
                                row.name,
                                row.sku_id,
                                row.is_multipack,
                                row.id
                              );
                              handleActionsMenuClose();
                            }}
                          >
                            <PrintIcon sx={{ mr: 1, fontSize: 18 }} />
                            Imprimir etiqueta
                          </MenuItem>,

                          <MenuItem
                            key="history"
                            onClick={() => {
                              handleOpenModalHistorial(row);
                              handleActionsMenuClose();
                            }}
                          >
                            <HistoryIcon sx={{ mr: 1, fontSize: 18 }} />
                            Historial
                          </MenuItem>,
                        ]}

                        {hasUpdatePermission && (
                          <MenuItem
                            onClick={() => {
                              handleOpenModalEdit(row);
                              handleActionsMenuClose();
                            }}
                          >
                            <EditIcon sx={{ mr: 1, fontSize: 18 }} />
                            Editar
                          </MenuItem>
                        )}

                        {/* Inhabilitar pega a /delete (permiso delete); habilitar
                            pega a /active (permiso update). Mostramos el toggle solo
                            si el usuario tiene el permiso que su estado actual exige,
                            alineado con el enforcement del backend. */}
                        {((row.active && hasDeletePermission) ||
                          (!row.active && hasUpdatePermission)) && (
                          <MenuItem
                            onClick={() => {
                              handleOpenConfirmDialog(row.id, row.active);
                              handleActionsMenuClose();
                            }}
                          >
                            <Switch
                              checked={row.active}
                              size="small"
                              color="primary"
                              sx={{ mr: 1 }}
                            />
                            {row.active ? "Inhabilitar" : "Habilitar"}
                          </MenuItem>
                        )}
                      </Menu>
                  </Box>
                ),
              },
            ]}
            loading={searchInventory}
            enablePagination
            totalItems={products?.paging?.total || 0}
            currentPage={products?.paging?.page - 1 || 0}
            rowsPerPage={products?.paging?.page_size || 10}
            onPageChange={(e, newPage) =>
              handleCreateProducto(newPage + 1, products?.paging?.page_size)
            }
            onRowsPerPageChange={(e) =>
              handleCreateProducto(1, parseInt(e.target.value, 10))
            }
            emptyMessage="No hay inventario disponible"
            tableStyle={{ width: "100%" }}
          />
        </Paper>

        <HistorialModal
          open={modalHistorialOpen}
          setOpen={handleCloseModalHistorial}
          productoSKU={productoSKU}
          productoNombre={productoNombre}
        />

        <CustomModal
          open={modalOpen}
          onClose={handleCloseModal}
          title={productoSKU ? "Editar Producto" : "Crear Producto"}
        >
          <CrearProducto
            handleCreateProducto={handleCreateProducto}
            productoSKU={productoSKU}
            handleCloseModal={handleCloseModal}
          />
        </CustomModal>

        <CustomModal
          open={modalOpenCombo}
          onClose={handleCloseModalCombo}
          title={productoSKU ? "Editar Combo" : "Crear Combo"}
        >
          <CrearProductoCombo
            handleCreateProducto={handleCreateProducto}
            productSKU={productoSKU}
            onClose={handleCloseModalCombo}
          />
        </CustomModal>

        <CustomModal
          open={openModalMultiPack}
          onClose={handleCloseModalMultiPack}
          title={productoSKU ? "Editar Multibulto" : "Crear Multibulto"}
        >
          <MultiBultoModal
            handleCreateProducto={handleCreateProducto}
            productSKU={productoSKU}
            onClose={handleCloseModalMultiPack}
          />
        </CustomModal>

        <LoadMasive
          open={openLoadMasiveModal}
          onClose={() => setOpenLoadMasiveModal(false)}
          handleCreateProducto={handleCreateProducto}
        />
        <ProductLabel
          open={printLabelOpen}
          setOpen={setPrintLabelOpen}
          ean={selectedLabel.ean}
          name={selectedLabel.name}
          sku={selectedLabel.sku}
          isMultipack={selectedLabel.isMultipack}
          multipackProducts={selectedLabel.multipackProducts}
        />
        <Dialog
          open={openConfirmDialog}
          onClose={handleCloseConfirmDialog}
          PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            {isEnabling ? "Habilitar producto" : "Inhabilitar producto"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "#555" }}>
              {isEnabling
                ? "¿Estás seguro de que deseas habilitar este producto?"
                : "¿Estás seguro de que deseas inhabilitar este producto? No estará disponible para operaciones."}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
            <Button
              onClick={handleCloseConfirmDialog}
              variant="outlined"
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleToggleStatus}
              color={isEnabling ? "primary" : "error"}
              disabled={loading}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Confirmar"
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={alertObj.severity}
            sx={{ width: "100%" }}
          >
            {alertObj.message}
          </Alert>
        </Snackbar>
      </Grid>
    </>
  );
};

export default Inventario;
